module.exports = __webpack_public_path__ + "img/女-子宫颈癌h.f548040c.png";